var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 20,
    viewBox: "0 0 15 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.40132 9.43231C9.4632 9.43231 11.1347 7.653 11.1347 5.4581C11.1347 3.2632 9.4632 1.48389 7.40132 1.48389C5.33945 1.48389 3.66797 3.2632 3.66797 5.4581C3.66797 7.653 5.33945 9.43231 7.40132 9.43231Z",
    fill: "#3C3C3C",
    stroke: "#3C3C3C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8 18.5161C13.8 16.7092 13.1258 14.9763 11.9255 13.6986C10.7253 12.421 9.09742 11.7032 7.40002 11.7032C5.70263 11.7032 4.07476 12.421 2.87452 13.6986C1.67429 14.9763 1 16.7092 1 18.5161H13.8Z",
    fill: "#3C3C3C",
    stroke: "#3C3C3C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user-icon.fdbe1e8ac63be46aa4c29f0ce054fb1e.svg";
export { ForwardRef as ReactComponent };